module.exports = __webpack_public_path__ + "img/145.734fdbe4.jpg";